<template>
  <transition name="el-zoom-in-top">
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <div>
      <div
        style="text-align: center; margin: 50px auto;">
        <img src="/static/img/logo.png" style="width: 240px; height: auto;">
      </div>
      <h2 style="text-align: center">输入手机号与密码登录</h2>
      <div style="width: 35%;margin:0 auto;padding:15px;">
        <el-form ref="form" :model="vo" label-width="0px" class="form-default">
          <el-col>
            <el-form-item>
              <el-input placeholder="请输入手机号码" type="text" id="inputUsernameEmail" v-model="vo.name" :autofocus="true"/>
            </el-form-item>
          </el-col>
<!--          <transition name="el-zoom-in-top">-->
<!--            <el-col v-if="vo.name != null && vo.name.length > 0">-->
<!--              <el-form-item>-->
<!--                <el-input placeholder="请输入短信验证码" type="vcode" id="vcode" v-if="vo.name != null"-->
<!--                          v-model="vo.vcode">-->
<!--                  <i slot="prefix" class="el-input__icon el-icon-key"></i>-->
<!--                </el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
<!--          </transition>-->
          <transition name="el-zoom-in-top">
            <el-col v-if="vo.name != null && vo.name.length > 0">
              <el-form-item>
                <el-input placeholder="请输入密码" type="password" id="inputPassword" v-if="vo.name != null"
                          v-model="vo.password"/>
              </el-form-item>
            </el-col>
          </transition>
          <transition name="el-zoom-in-top">
            <el-col v-if="vo.name != null && vo.name.length > 0 && vo.password != null && vo.password.length > 0">
              <el-form-item>
                <el-switch
                  v-model="autoLogin"
                  active-text="下次自动登录"
                  active-color="#13ce66"
                  inactive-color="#D4D4D4">
                </el-switch>
              </el-form-item>
            </el-col>
          </transition>
          <transition name="el-zoom-in-center">
            <el-col v-if="vo.name != null && vo.name.length > 0 && vo.password != null && vo.password.length > 0">
              <el-form-item>
                <el-button style="width: 100%;" round type="primary" @click="onSubmit" native-type="submit">
                  登录
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="agreeProtocol">阅读并同意<el-link type="info" @click="dialogFormVisible = true">《产品许可与服务协议》<i class="el-icon-view" /></el-link></el-checkbox>
              </el-form-item>
            </el-col>
          </transition>
        </el-form>
      </div>
      <div style="position:fixed;height:30px;bottom:0px;text-align:center;width:100%;color:#222;font-size:16px">
        Copyright © 2021 广州市东迅电脑科技有限公司. All Rights Reserved.   <a href="https://beian.miit.gov.cn" id="beian" target="_blank">粤ICP备2021161829号</a>
      </div>

      <!-- 用户协议弹窗 -->
      <el-dialog title="产品许可与服务协议" :visible.sync="dialogFormVisible" width="80%">
        <div style="width: 100%; max-height: 550px; overflow:auto; padding: 1rem; margin-bottom: 1rem; border: 1px solid #dadde5;">
          <Protocol></Protocol>
        </div>
        <div style="width: 100%; text-align: center">
          <el-button type="primary" @click="agreeProtocol = true; dialogFormVisible = false;">同意</el-button>
          <el-button @click="dialogFormVisible = false; agreeProtocol = false;">取消</el-button>
        </div>
      </el-dialog>
      <!-- 用户协议弹窗 END -->
    </div>
    <!-- /.content -->
  </transition>
</template>
<script>
  import Protocol from "./Protocol";
  export default {
    components: {Protocol},
    data: function () {
      return {
        autoLogin: false,
        dialogFormVisible: false,
        agreeProtocol: false,
        vo: {
          name: null,
          password: null
        }
      }
    },
    //  创建一个页面的路由监听 （此处不能用 this）
    beforeRouteEnter: function (to, from, next) {
      next(vm => {
        vm.initView(to.query);
      });
    },
    // 重用一个页面，需要监听路由变化
    beforeRouteUpdate: function (to, from, next) {
      this.initView(to.query);
      next();
    },
    methods: {
      initView: function (query) {
        if (query.redirect) {
          this.toPath = query.redirect;
        }
        if (localStorage.autoLogin === "true") {
          this.tokenLogin();
        }
      },
      tokenLogin: function () {
        this.axios.post('/admin/auth/loginByToken', []).then(resp => { // 登录成功 跳转首页
          if (resp.data && resp.data.code === 200) {
            var result = resp.data.data
            var userInfo = {};
            userInfo.name = result.name
            userInfo.staffName = result.staffName
            userInfo.phone = result.phone;
            userInfo.roles = result.roles;
            if (result.avatarUrl) {
              userInfo.avatarUrl = result.avatarUrl
            } else {
              userInfo.avatarUrl = "/static/img/avatar2.png";
            }
            userInfo.type = result.type;
            userInfo.departmentName = result.departmentName;
            userInfo.departmentId = result.departmentId;
            this.$store.commit("SET_USERINFO", userInfo);
            this.$store.commit("SET_LOGIN", true);
            this.$message({
              type: 'success',
              message: '欢迎回来!'
            })
            if (this.toPath) {
              this.$router.replace(this.toPath);
            } else {
              this.$router.replace('./home')
            }
          } else {
            this.$message({
              type: 'error',
              message: resp.data.message
            })
          }
        }).catch(resp => {
          this.$message({
            type: 'error',
            message: '服务器繁忙，请稍后再试!'
          })
        })
      },
      onSubmit: function () {
        if (!this.agreeProtocol) {
          this.$message({
            type: 'error',
            message: '请先阅读并同意《产品许可与服务协议》!'
          })
        } else if (this.vo.name === '' || this.vo.password === '') {
          this.$message({
            type: 'error',
            message: '请确认用户名或密码!'
          })
        } else {
          this.axios.post('/admin/auth/login', [], {
            params: {
              phone: this.vo.name,
              userPD: this.vo.password
            }
          }).then(resp => { // 登录成功 跳转首页
            if (resp.data && resp.data.code === 200) {
              var result = resp.data.data;
              // console.log(result)
              var userInfo = {};
              userInfo.name = result.name
              userInfo.staffName = result.staffName
              userInfo.phone = result.phone;
              userInfo.roles = result.roles;
              if (result.avatarUrl) {
                userInfo.avatarUrl = result.avatarUrl
              } else {
                userInfo.avatarUrl = "/static/img/avatar2.png";
              }
              if (this.autoLogin) {
                localStorage.autoLogin = true
              } else {
                localStorage.autoLogin = false
              }
              localStorage.token = result.token
              userInfo.type = result.type;
              userInfo.departmentName = result.departmentName;
              userInfo.departmentId = result.departmentId;
              this.$store.commit("SET_USERINFO", userInfo);
              this.$store.commit("SET_LOGIN", true);

              this.axios.defaults.headers.common['Authorization'] = 'token ' + window.localStorage.getItem('token')
              // console.log(result)
              this.$message({
                type: 'success',
                message: '登录成功!'
              })
              this.$router.replace('./home')
            } else {
              this.$message({
                type: 'error',
                message: resp.data.message
              })
            }
          }).catch(resp => {
            this.$message({
              type: 'error',
              message: '服务器繁忙，请稍后再试!'
            })
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?0a24647c